import React from 'react';
import {
  ControlProps,
  isEnumControl,
  OwnPropsOfEnum,
  RankedTester,
  rankWith,
} from '@jsonforms/core';
import { withJsonFormsEnumProps } from '@jsonforms/react';
import { MuiAutoComplete } from './mui-controls/MuiAutoComplete';
import { MaterialInputControl } from './controls/MaterialInputControl';

// Concrete implementation
class ConcreteMaterialInputControl extends MaterialInputControl {}

export const MaterialAutoCompleteControl = (
  props: ControlProps & OwnPropsOfEnum,
) => <ConcreteMaterialInputControl {...props} input={MuiAutoComplete} />;

export const materialEnumControlTester: RankedTester = rankWith(
  5,
  isEnumControl,
);

export default withJsonFormsEnumProps(MaterialAutoCompleteControl);
